import React from 'react';

/**
 * Detail row component for displaying label-value pairs in drawers.
 */
export const DetailRow = ({ label, value }) => (
    <div className="flex justify-between text-sm border-b border-transparent hover:border-notion-border pb-1 transition-colors">
        <span className="text-stone-500">{label}</span>
        <span className="text-stone-700 font-medium text-right max-w-[200px]">{value}</span>
    </div>
);

export default DetailRow;
